import { Link } from '@tanstack/react-router';

import { useStore } from '@tanstack/react-store';

import { data } from '~/data/basic';
import { langStore } from '~/store/langStore';
import LayeredButton from './LayeredButton';

export default function Volunteer() {
  const locale = useStore(langStore, s => s);

  return (
    <div
      className="
      bg-onkentes2 flex
      h-[800px]
      w-full
      justify-center
      bg-cover bg-position-[76%_10%]
      bg-no-repeat
      pt-40
      md:bg-center
    "
    >
      <div className="z-10 flex flex-col items-center gap-5">
        <div className="p-5 text-2xl font-bold text-nowrap text-white shadow-2xl md:text-4xl">
          {data.homepage.participate.title[locale]}
        </div>
        <Link to="/volunteer">
          <LayeredButton text={data.homepage.participate.participate[locale]} />
        </Link>
      </div>
    </div>
  );
}
